.form {
  width: 100%;
}

.select {
  width: 100%;
}
